import React from "react"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper/modules";
import 'swiper/css';
import "./PartnerCompanies.css"

const imageUrl = [
  'images/successlogo/1.png',
  'images/successlogo/2.png',
  'images/successlogo/3.png',
  'images/successlogo/4.png',
  'images/successlogo/5.png',
  'images/successlogo/6.png',
  'images/successlogo/7.png',
  'images/successlogo/8.png',
  'images/successlogo/9.png',
  'images/successlogo/10.png',
  'images/successlogo/11.png',
  'images/successlogo/12.png',
  'images/successlogo/13.png',
  'images/successlogo/14.png',  //Renew RR
  'images/successlogo/15.png',
  'images/successlogo/16.png',  //Renew Savor
  'images/successlogo/17.png',
  'images/successlogo/18.png',
  // 'images/successlogo/19.png',
  'images/successlogo/20.png',   //Renew thairoom
  'images/successlogo/21.png',
  'images/successlogo/22.png',
  'images/successlogo/23.png',
  'images/successlogo/24.jpg',
  'images/successlogo/25.jpg',
  'images/successlogo/26.png',
]

function PartnerCompanies() {
  return (
  <div className='partnerCompanies_container container standard-padding-space'>
      <div className="blog-text-content text-center mb-5">
          {/* <p className="sub-heading">Lotus Accounting</p> */}
          <h5 className='sub-heading mb-3 font-atwick' style={{fontWeight:"bolder",fontSize:"2rem",letterSpacing:"1px",fontFamily:"atwic",textTransform:"none"}}>Lotus Accounting</h5>
          <h3 className="body-heading">Client success stories</h3> 
        </div>
        <div className="companies-logo-box mx-1 py-3 px-0">
        <Swiper
            spaceBetween={50}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Autoplay]}
            breakpoints={{
                200:{
                  slidesPerView: 1,
                },
                550: {
                  slidesPerView: 2,
                },
                800: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 5,
                }
              }}
            className="p-3 px-0 mx-auto align-items-center"
            >
              {
                imageUrl.map((ele)=>{
                  return(
                    <SwiperSlide className="d-flex align-items-center h-auto">
                      <img loading="lazy" src={ele} alt="logo" style={{maxWidth:"80%",maxHeight:"80%"}} />
                    </SwiperSlide>
                  )
                })
              }
        </Swiper>
        </div>
    </div>
  )
}

export default PartnerCompanies